import { Film, Loader2, Download, AlertCircle } from "lucide-react";
import { toast } from "sonner";
import { http, errMsg, fileUrl, safeName } from "@/lib/api";
import { Button } from "@/components/ui/button";

export const FullEpisode = ({ ep, approved, reload }) => {
  const running = ep.full_status === "running";
  const build = async () => {
    try { await http.post(`/episodes/${ep.id}/build-full`); toast("Joining approved scenes into one episode file…"); await reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="panel p-4 flex flex-wrap items-center gap-3" data-testid="full-episode-panel">
      <Film className="w-4 h-4 text-amber-400" />
      <div className="text-sm">
        <div className="font-medium">Full episode file</div>
        <div className="text-[11px] text-slate-500" data-testid="full-episode-status">
          {running ? "Joining scenes in order…"
            : ep.full_status === "failed" ? <span className="text-red-400">Failed: {ep.full_error}</span>
            : ep.full_path ? (!approved ? "No approved scenes now — the last build is outdated." : ep.full_stale ? "Approved scenes changed since the last build — rebuild to include them." : "Up to date with all approved scenes.")
            : `Joins all ${approved} approved scenes in order into one video.`}
        </div>
      </div>
      <div className="ml-auto flex gap-2">
        <Button data-testid="build-full-btn" size="sm" variant="secondary" disabled={running || !approved} onClick={build} className="rounded-full">
          {running ? <Loader2 className="w-3.5 h-3.5 mr-1.5 animate-spin" /> : ep.full_stale ? <AlertCircle className="w-3.5 h-3.5 mr-1.5" /> : <Film className="w-3.5 h-3.5 mr-1.5" />}
          {ep.full_path ? "Rebuild" : "Build episode"}
        </Button>
        {ep.full_path && !running && (
          <a data-testid="download-full-btn" href={fileUrl(ep.full_path, `${safeName(ep.title)}_full_episode.mp4`)}
            className="inline-flex items-center gap-1.5 px-4 h-9 rounded-full bg-amber-500 text-black text-sm font-medium hover:bg-amber-400 transition-colors">
            <Download className="w-4 h-4" />Episode .mp4
          </a>
        )}
      </div>
    </div>
  );
};
